import '../pages.scss';
import Snackbar from '../../components/snackbar.mjs';
import TopNavBar from '../../components/topNavBar.mjs';
import { useNavigate } from "react-router-dom";


const WatchLivestreamPage = () => {
  const navigate = useNavigate();
  const keygenID = sessionStorage.getItem('keygenID');
  const keygenToken = sessionStorage.getItem('userToken');

  let remoteStream = null;
  var streamStatus = "Inactive";
  const servers = {
    iceServers: [
      {
        urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302'],
      },
    ],
    iceCandidatePoolSize: 10,
  };

  const pc = new RTCPeerConnection(servers);

  const makeFullScreen = () => {
    const elem = document.getElementById("local-video");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  const startLivestreamWithLog = async () => {
    const startLivestream = async () => {
      if (streamStatus !== "Inactive") {
        return;
      }

      var ip;
      var instID;
      await fetch("/getReservations/?userID=" + keygenID + "&token=" + keygenToken) // Check that there is an instance reserved for the user
        .then(response => response.json())
        .then(data => {
          if (data === "Not Authorized") {
            sessionStorage.clear();
            navigate("/");
            return;
          }
          //console.log(data);
          for (let res of data) {
            for (let instance of res["Instances"]) {
              //console.log("inspecting inst of reservation");
              for (let tag of instance["Tags"]) {
                if (tag.Key === "UserID" && tag.Value === keygenID) { // There is an instance reserved for userID
                  instID = instance["InstanceId"];
                  ip = instance["PublicIpAddress"];
                }
              };
            }
          };
        })
    
      if (ip === undefined || instID === undefined) {
        Snackbar("noInst", 10000);
        return;
      }

      streamStatus = "Starting";

      Snackbar("startSnackbar", 10000);

      var offer;
      await fetch("/generateOffer/?keygenID=" + keygenID + "&token=" + keygenToken + "&ip=" + ip + "&instID=" + instID)
      .then(response => response.json())
      .then(data => {
        if (data === "Not Authorized") {
          sessionStorage.clear();
          navigate("/");
          return;
        }

          offer = data;
      })
      .catch(error => console.log(error));

      remoteStream = new MediaStream();

      pc.ontrack = (event) => {
        event.streams[0].getTracks().forEach((track) => {
          remoteStream.addTrack(track);
        });
      };

      // Print for testing purposes
      pc.ondatachannel = e => {
          const receiveChannel = e.channel;
          receiveChannel.onmessage = e =>  console.log("Message received on channel: "  + e.data );
          receiveChannel.onopen = e => console.log("The channel is open.");
          receiveChannel.onclose = e => console.log("The channel is closed.");
          pc.channel = receiveChannel;
      }
        
      await pc.setRemoteDescription(offer);

      const answer = await pc.createAnswer();
      await pc.setLocalDescription(answer);

      document.getElementById("local-video").srcObject = remoteStream;
      fetch("/answer/" + keygenID + "/" + keygenToken + "/", {
        method: 'POST',
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          
        },
        body: JSON.stringify(pc.localDescription)
      }).catch(error => console.log(error));
      streamStatus = "Active";
    }

    await startLivestream();
  }
    return (
      <>
      <div>
        <TopNavBar></TopNavBar>
      </div>
      <div className="page" id="liveStreamPage">
        <div style={{height:'70px', width:'1120px', marginBottom:'50px'}}></div>
        
        <br></br>
        <br></br>

        <div className="snackbarNormal" id="startSnackbar">Starting the livestream. Please be patient</div>
        <div className="snackbarRed" id="noInst">The livestream could not be started. Make sure your server has been started</div>

        <div style={{display:'inline-block', marginTop:'0px'}}>
          <p style={{fontSize:'14px'}}>Livestream your view from syGlass Cloud</p>
        </div>

        <div className="video-player" style={{margin:'auto'}}>
          <video className="video" id="local-video" muted autoPlay></video>
          <input className="video-content" type="image" alt="Expand Video" src="../assets/expand-icon.png" onClick={makeFullScreen} />
        </div>
        <br></br>

        <div style={{display:'inline-block', marginTop:'0px'}}>
          <button className="btn" style={{width:'204px', marginTop:'0px'}} onClick={startLivestreamWithLog}>Display my view</button>
        </div>
    </div>
    </>
    )
}

export default WatchLivestreamPage;